import { gql } from '@apollo/client'

export const GetTranslationLanguagesQuery = gql`
  query getTranslationLanguages {
    translationLanguages {
      languages
    }
  }
`
